const MAX_FILENAME_LENGTH = 33

export const truncateFilename = (
  name: string,
  maxLength = MAX_FILENAME_LENGTH
): string => {
  if (name.length <= maxLength) return name
  const lastDot = name.lastIndexOf('.')
  if (lastDot === -1) return name.slice(0, maxLength - 3) + '...'
  const extension = name.slice(lastDot)
  const baseName = name.slice(0, lastDot)
  const maxBaseLen = maxLength - 3 - extension.length
  if (maxBaseLen <= 0) return name.slice(0, maxLength - 3) + '...'
  return baseName.slice(0, maxBaseLen) + '... ' + extension
}
